import TipTipStatus from './TipTipStatus'

export default TipTipStatus
